import { Injectable, createComponent, ApplicationRef, Injector, Type, EmbeddedViewRef, ComponentRef, EnvironmentInjector } from '@angular/core';
import { DialogModule } from './dialog.module';
import { DialogComponent } from './dialog.component';
import { DialogInjector } from './dialog-injector';
import { DialogConfig } from './dialog-config';
import { DialogRef } from './dialog-ref';
import { AlertComponent } from './alert/alert.component';
import { TermsAndConditionDynamicComponent } from './terms-and-condition-dynamic/terms-and-condition-dynamic.component';
import { ErrorComponent } from './error/error.component';

class alertModel {
  action?: string = 'alert';
  title?: string = "Warning!";
  description?: string = "";
  btnText?: string = "OK";
}

class DialogModel {
  action?: string = 'alert';
  title?: string = "Warning!";
  description?: string = "";
  btnText?: string = "OK";
  btnCancel?: string = 'Cancel'
  btnConfirm?: string = 'Yes'
}

@Injectable({
  providedIn: DialogModule
})
export class DialogService {
  constructor(private appRef: ApplicationRef, private injector: Injector, private environmentInjector: EnvironmentInjector) { }

  public open(data: DialogModel) {
    let config = new DialogConfig();
    config.data = data;
    return this.exec(AlertComponent, config);
  }

  public confirm(title: string, message: string, btnOkText?: string, btnCancelText?: string, dialogSize?: "sm" | "lg", options?: any) {

    let data = new DialogModel();
    data.action = 'confirm';
    data.title = title;
    data.description = message;
    if (btnOkText) {
      data.btnConfirm = btnOkText;
    }
    if (btnCancelText) {
      data.btnCancel = btnCancelText;
    }
    //do not show btnCancel 
    if (options && options.isshowbtnCancel == false) {
      data.btnCancel = '';
    }

    let config = new DialogConfig();
    config.data = data;
    return this.exec(AlertComponent, config);
  }

  public alert(data: alertModel) {
    let config = new DialogConfig();
    config.data = data;
    return this.exec(AlertComponent, config);
  }

  public error(data: any) {
    let config = new DialogConfig();
    config.data = data
    return this.exec(ErrorComponent, config);
  }

  public terms(data: any) {
    let config = new DialogConfig();
    config.data = data
    return this.exec(TermsAndConditionDynamicComponent, config);
  }

  private exec(componentType: Type<any>, config: DialogConfig) {
    return this.appendDialogComponentToBody(componentType, config);
  }

  private appendDialogComponentToBody(componentType: Type<any>, config: DialogConfig) {
    const map = new WeakMap();
    map.set(DialogConfig, config);
    const dialogRef = new DialogRef();
    map.set(DialogRef, dialogRef);
    const componentRef = createComponent(DialogComponent, { 
      environmentInjector: this.environmentInjector,
      elementInjector: new DialogInjector(this.injector, map)
    })
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    componentRef.instance.childComponentType = componentType;
    componentRef.instance.onClose.subscribe(() => {
      this.removeDialogComponentFromBody(componentRef);
    });
    const sub = dialogRef.afterClosed.subscribe(() => {
      this.removeDialogComponentFromBody(componentRef);
      sub.unsubscribe();
    });
    return dialogRef;
  }
  private removeDialogComponentFromBody(componentRef) {
    this.appRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }
}
